import type {
  OrganizationSearchEstablishment,
  OrganizationSearchResult,
} from '../types/organization-search-result.type';

import { resolveHeadOfficeEstablishment } from './resolve-head-office-establishment.util';

export interface EstablishmentListItem {
  readonly establishment: OrganizationSearchEstablishment;
  readonly isHeadOffice: boolean;
}

export const buildEstablishmentsList = (
  result: Readonly<OrganizationSearchResult>,
): readonly EstablishmentListItem[] => {
  const headOffice = resolveHeadOfficeEstablishment(result);

  return [
    ...(headOffice ? [{ establishment: headOffice, isHeadOffice: true }] : []),
    ...(result.matching_etablissements ?? [])
      .filter((establishment) => establishment.siret !== headOffice?.siret)
      .map((establishment) => ({
        establishment,
        isHeadOffice: false,
      })),
  ];
};
